module.exports = __webpack_public_path__ + "static/img/img_tip_success.898d729d.png";